import {TProductsType} from "./types";

const Categories: TProductsType = {
Bun: {
    type: 'bun',
    text: 'Булки',
},
Sauce: {
    type: 'sauce',
    text: 'Соусы',
},
Main: {
    type: 'main',
    text: 'Начинки'
}
,
}
export default Categories;
